import { Post } from "services/apiService";
import { SOMS_API_KEY, BASE_URL } from "services/CONSTANTS";
import {
  GET_AMEND_MANUAL_ORDERS_REQUEST,
  GET_AMEND_MANUAL_ORDERS_SUCCESS,
  GET_AMEND_MANUAL_ORDERS_ERROR,
} from "./action-type";

export const getManualOrders =
  ({ limit, offset, requestBody }) =>
  async (dispatch) => {
    const apiUrl = `${BASE_URL}orders/@fetchorders?apikey=${SOMS_API_KEY}&offset=${offset}&limit=${limit}`;

    dispatch({ type: GET_AMEND_MANUAL_ORDERS_REQUEST });

    Post({
      url: apiUrl,
      params: requestBody,
      config: {},
    })
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: GET_AMEND_MANUAL_ORDERS_SUCCESS,
            payload: response.data,
          });
        } else {
          dispatch({
            type: GET_AMEND_MANUAL_ORDERS_ERROR,
            payload: response.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: GET_AMEND_MANUAL_ORDERS_ERROR,
          payload: error.response.data,
        });
      });
  };
